import React from 'react';
import { PageLink } from 'models/PageLink';

export function buildAlternateLinks(
  pageLinks: PageLink[]
): JSX.Element[] | undefined {
  if (!pageLinks || !Array.isArray(pageLinks) || pageLinks.length === 0) {
    return;
  }

  return pageLinks.map(({ url, language }) => (
    <link rel="alternate" href={url} hrefLang={language} key={language} />
  ));
}
